import { Controller, useFormContext } from 'react-hook-form';
import { TextQuestionProps } from '../../types';
import { TextInput } from '../components/text-input';

export const TextQuestion = ({ question }: TextQuestionProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={question.slug}
      render={({ field: { onChange, value } }) => (
        <TextInput
          value={value ?? ''}
          onChange={onChange}
          placeholder={question.placeholder?.toString()}
        />
      )}
      rules={{ required: question.required }}
      defaultValue=""
    ></Controller>
  );
}
